import { render, staticRenderFns } from "./ModificaAsseverazione.vue?vue&type=template&id=289260b9&scoped=true&"
import script from "./ModificaAsseverazione.vue?vue&type=script&lang=js&"
export * from "./ModificaAsseverazione.vue?vue&type=script&lang=js&"
import style0 from "./ModificaAsseverazione.vue?vue&type=style&index=0&id=289260b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289260b9",
  null
  
)

export default component.exports